/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class PreventiveSheet {
    constructor(data) {
        if (data) {
            Object.assign(this, data);
        } else {
            this.status = 'OPENED';
            this.checklist = [];
        }

        this.checklist.forEach(check => {
            if (check.type === "DATE") {
                if (check.dateValue === null) {
                    check.dateValue = new Date(Date.now());
                } else {
                   check.dateValue = new Date(check.dateValue);
                }
            }
            if (check.type === "DATE_TIME") {
                if (check.dateTimeValue === null) {
                    check.dateTimeValue = this.getDateWithoutSecond(Date.now());
                } else {
                    check.dateTimeValue = this.getDateWithoutSecond(check.dateTimeValue);
                }
            }
        });

        this.checksByCategory = {};
        this.checklist.forEach(check => {
            if (!angular.isArray(this.checksByCategory[check.category])) {
                this.checksByCategory[check.category] = [];
            }
            this.checksByCategory[check.category].push(check);
        });
        this.category = Object.keys(this.checksByCategory);
    }

    /**
     * Convert a string date to a Date format YYYY-mm-dd hh:mm
     *
     * @param {String} the string date
     */
    getDateWithoutSecond(stringDate) {
        let date = new Date(stringDate);
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes());
    }
}

export { PreventiveSheet };



// WEBPACK FOOTER //
// ./src/main/front/scripts/model/PreventiveSheet.js